import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { statusSteps, getStatusIndex, theme } from './theme';

// Status illustration images
const statusImages = {
  planned: '/img/maintenance_status_planned.png',
  in_progress: '/img/maintenance_status_in_progress.png',
  completed: '/img/maintenance_status_completed.png',
  picked_up: '/img/maintenance_status_picked_up.png',
  waiting: '/img/maintenance_status_in_progress.png',
  vehicle_in_workshop: '/img/maintenance_status_planned.png',
};

// Side states use their own label key instead of the mapped step's label
const sideStatusLabelKeys = {
  waiting: 'status_waiting',
  vehicle_in_workshop: 'status_vehicle_in_workshop',
};

const StatusIllustration = ({ status, statusColors }) => {
  const { t } = useTranslation();
  const currentIndex = getStatusIndex(status);
  const currentStep = statusSteps[currentIndex] || statusSteps[0];
  const labelKey = sideStatusLabelKeys[status] || currentStep.labelKey;

  const imageSrc = statusImages[status] || statusImages.planned;

  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: theme.colors.surface,
        borderRadius: theme.radius.xl,
        padding: '20px',
        boxShadow: theme.shadows.md,
        marginBottom: '20px',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
        <img
          src={imageSrc}
          alt={t(`public_maintenance.${labelKey}`)}
          style={{ width: '100%', maxWidth: '280px', height: 'auto' }}
        />
      </Box>
      <Typography
        sx={{
          fontSize: '24px',
          fontWeight: '700',
          color: statusColors.main,
        }}
      >
        {t(`public_maintenance.${labelKey}`)}
      </Typography>
    </Paper>
  );
};

export default StatusIllustration;
